import * as React from 'react';
import { connect } from 'react-redux';
import IconButton from '../common/IconButton';
import NewToolbarItemScroller from '../common/toolbar-item-scroller/NewToolbarItemScroller';
import CurrentToolIcon from '../header-toolbar/CurrentToolIcon';
import UIAction from '../../actions/ui/UIAction';
import { CurrentTool } from '../../reducers/ui/ui';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../reducers/app';
import { tabFocusSelf } from '../../reducers/pages';
import { mapStateToZoomable } from '../../selectors/zoomingSelector';
import * as ViewAction from '../../actions/ViewAction';
import NewZoomSlider from '../common/NewZoomSlider';

interface HeaderToolbarZoomLevelProps {
  readonly isVertical: boolean;
  readonly activePanelID: string;
  readonly popToTopLevel: () => void;
  readonly dispatch: Dispatch<Action>;
  readonly zoomOutEnabled: boolean;
}

const HeaderToolbarZoomLevel: React.SFC<HeaderToolbarZoomLevelProps> = React.memo((props) => {
  const { isVertical, activePanelID, dispatch, popToTopLevel } = props;

  return <>
    <CurrentToolIcon />

    <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
      <IconButton
        title="スポットズーム"
        imagePath="images/tool-icons/new/spot_zoom/spot_zoom"
        rouondRect={true}
        onClick={() => { UIAction.setCurrentTool(CurrentTool.RegionZoom, dispatch); }}/>
      <IconButton
        title="100%表示"
        imagePath="images/tool-icons/new/100_indication/100_indication"
        rouondRect={true}
        disabled={!props.zoomOutEnabled}
        onClick={() => dispatch(ViewAction.resetZoom(activePanelID))} />
      <NewZoomSlider roundRectButton={true} />
    </NewToolbarItemScroller>

    <IconButton
      title="戻る"
      imagePath="images/tool-icons/new/btn_top/btn_top"
      rouondRect={true}
      onClick={popToTopLevel} />
  </>;
});

const mapStateToProps = (appStates: AppStates) => {
  const { pages } = appStates;
  const tab = pages.tabs[pages.activeTab];
  const panelID = tab.focus === tabFocusSelf ? tab.id : tab.focus;
  const { zoomOutEnabled } = mapStateToZoomable(appStates, { panelID });
  return {
    zoomOutEnabled,
    activePanelID: panelID,
  };
};

export default connect(mapStateToProps)(HeaderToolbarZoomLevel);
